import { I18n as I18nCore } from '@insolus/i18n';
import wrapValidator from '@insolus/prop-types/wrapValidator';

var getClassName = function getClassName(obj) {
  if (!obj.constructor || !obj.constructor.name) {
    return "Unknown class";
  }

  return obj.constructor.name;
};

var createI18nInstanceTypeChecker = function createI18nInstanceTypeChecker() {
  var validate = function validate(props, propName, componentName, location, propFullName) {
    if (!I18nCore.isI18n(props[propName])) {
      var actualClassName = getClassName(props[propName]);
      return "Invalid ".concat(location, " `").concat(propFullName, "` of type `").concat(actualClassName, "` ") + "supplied to `".concat(componentName, "`, expected an I18n instance.");
    }

    return null;
  };

  return wrapValidator(validate);
};

export default {
  i18nInstance: createI18nInstanceTypeChecker()
};